module.exports = __webpack_public_path__ + "static/img/logo.23eadd5e.png";